import { BaseApi } from '../../../api/apiBase'
import { CustomPageListItem, CustomPageDetail } from '../../types/customPage'

class V1CustomPagesApi extends BaseApi {
    async getCustomPages(eventSlug: string): Promise<CustomPageListItem[]> {
        // V1 events use the same list endpoint
        const response = await this.getSimpleJson<{ data: CustomPageListItem[] }>(
            `/events/${eventSlug}/content_pages`
        )
        return response.data || []
    }

    async getCustomPage(eventSlug: string, pageSlug: string): Promise<CustomPageDetail> {
        // V1 events use the v1 namespace route
        // Use standard get method to handle JSON:API response
        return this.get<CustomPageDetail>(
            `/events/${eventSlug}/v1/content_pages/${pageSlug}`,
            { include: 'sections' }
        )
    }
}

export const v1CustomPagesApi = new V1CustomPagesApi()